module.exports = __webpack_public_path__ + "img/stop-ic-f.7f77bdfc.png";